module.exports = __webpack_public_path__ + "static/media/yellow_nebula_UP.e79f3f28.png";